import { FC, MouseEventHandler, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { IJobBase, MessageType } from '@/types'
import Icon from '@/public/images/common/bookmark_v2.svg'
import { useStores } from '@/utils'
import { IconButton2 } from '@components-v2/atoms/IconButton2'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const BookarkJobIconButton: FC<Props> = observer(({ job }) => {
  const { t } = useTranslation('jobs')
  const { messages, viewer } = useStores()
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {}, [viewer.viewer?.myJobBookmarks])

  const addMyJobBookmark = async () => {
    if (viewer.isSignedIn) {
      setIsSubmitting(true)
      const isSuccessful = await viewer.viewer?.addMyJobBookmark(job?.id)
      if (isSuccessful) {
        messages.add({
          type: MessageType.Info,
          body: t('募集を保存しました'),
          isTranslated: true,
          ttl: 5000,
        })
      }
      setIsSubmitting(false)
    }
  }

  const removeMyJobBookmark = async () => {
    if (viewer.isSignedIn) {
      setIsSubmitting(true)
      const isSuccessful = await viewer.viewer?.removeMyJobBookmark(job.id)
      if (isSuccessful) {
        messages.add({
          type: MessageType.Info,
          body: t('保存を解除しました'),
          isTranslated: true,
          ttl: 5000,
        })
      }
      setIsSubmitting(false)
    }
  }

  const isBookmarked = viewer.viewer?.myJobBookmarks.some((j) => j?.job?.id === job?.id) ?? false

  const toggleBookmark: MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault()

    if (isBookmarked) {
      await removeMyJobBookmark()
    } else {
      await addMyJobBookmark()
    }
  }

  if (!viewer?.isSignedIn) {
    return <></>
  }

  return (
    <div className={styles.container}>
      <IconButton2
        size='lg'
        icon={<Icon viewBox='0 0 24 24' />}
        hierarchy={isBookmarked ? 'tertiary-color' : 'tertiary-gray'}
        onClick={toggleBookmark}
        disabled={isSubmitting}
      />
    </div>
  )
})
